export default __webpack_public_path__ + "static/certification-qualiopi-384c75d9b1fd8830138acc1757894707.pdf";